export default __webpack_public_path__ + "static/media/logo.77927ea8.svg";